export default {"src":"/_next/static/image/public/images/ic_night.d39c1ca919bcfb9d7f2c7e73528d6d15.svg","height":18,"width":18};